/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import * as CardComponents from '../cards';
import { getComponentFromName } from '../../lib/utils';

import styles from '../../../styles/lists/cards.module.scss';

const propTypes = {
    items: AppPropTypes.cards,
    itemType: PropTypes.string,
    forwardedRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.instanceOf(Element),
        }),
    ]),
    onScroll: PropTypes.func,
    cardClassName: PropTypes.string,
    className: PropTypes.string,
    visible: PropTypes.bool,
};

const defaultProps = {
    items: null,
    itemType: null,
    onScroll: null,
    forwardedRef: null,
    cardClassName: null,
    className: null,
    visible: false,
};

const Cards = ({
    items,
    itemType,
    forwardedRef,
    onScroll,
    cardClassName,
    className,
    visible,
    ...props
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        ref={forwardedRef}
        onScroll={onScroll}
    >
        {(items || []).map((item, itemIndex) => {
            const { type = null } = item || {};
            const CardComponent =
                item !== null ? getComponentFromName(CardComponents, type || itemType) : null;
            return CardComponent !== null ? (
                <div
                    key={`item-${itemIndex + 1}`}
                    style={{ transitionDelay: `${0.2 + itemIndex * 0.1}s` }}
                    className={classNames([
                        styles.cardWrapper,
                        {
                            [styles.visible]: visible,
                        },
                    ])}
                >
                    <CardComponent
                        item={item}
                        index={itemIndex}
                        className={classNames([
                            styles.card,
                            {
                                [cardClassName]: cardClassName !== null,
                            },
                        ])}
                        {...props}
                    />
                </div>
            ) : null;
        })}
    </div>
);

Cards.propTypes = propTypes;
Cards.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <Cards {...props} forwardedRef={ref} />);
